// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import VueRouter from 'vue-router';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster'; // Obligatoire après la version 0.9.0
import JsonExcel from 'vue-json-excel';
import Vue2TouchEvents from 'vue2-touch-events';
import VueScrollStop from 'vue-scroll-stop';

import { ServerTable, ClientTable } from 'vue-tables-2';
import Root from './Root';
import store from './store/store';
import router from './router/index';

// Vue.config.productionTip = false;
Vue.use(VueRouter);
/* eslint-disable no-undef */
Vue.use(ClientTable, {}, false, 'bulma', 'default');
Vue.use(ServerTable, {}, false, 'bulma', 'default');
Vue.use(Buefy);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCv-YvtnpWFMggWL7BoyahVNxgVPZA9qsE',
    libraries: 'places',
  },
});
Vue.use(Vue2TouchEvents);
Vue.use(VueScrollStop);

Vue.component('GmapCluster', GmapCluster);
Vue.component('downloadExcel', JsonExcel);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Root),
});



// WEBPACK FOOTER //
// ./src/main.js